import React, { ReactNode, useMemo } from "react";

import { INavigateOptions } from "../../router/INavigateOptions";
import { IRoutes } from "../../router/IRoutes";
import { convertRoutesToGenerator } from "./ConvertRoutesToGenerator";
import { RouteGenerators } from "./RouteGenerators";
import { RouterContext } from "./RouterContext";

interface IRouterContextProviderProps {
    routes: IRoutes;
    navigate: (to: string, options?: INavigateOptions) => Promise<void>;
    children: ReactNode;
}

export function RouterContextProvider(props: IRouterContextProviderProps) {
    const { navigate, routes, children } = props;

    const routeTo = useMemo<RouteGenerators>(
        () => convertRoutesToGenerator(routes),
        [routes],
    );

    const value = useMemo(() => ({ navigate, routeTo }), [navigate, routeTo]);
    return (
        <RouterContext.Provider value={value}>
            {children}
        </RouterContext.Provider>
    );
}
